import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['dialog'];

  static values = { open: Boolean };

  connect() {
    this.#onBeforeRender = (event) => {
      if (event.detail.renderMethod !== 'morph') this.close();
    };

    this.#onBeforeMorph = (event) => {
      if (event.target === this.dialogTarget && this.dialogTarget.open) event.preventDefault();
    };

    this.#onSubmitEnd = (event) => {
      if (event.detail.success && this.element.contains(event.target)) this.close();
    };

    window.addEventListener('turbo:before-render', this.#onBeforeRender);
    document.addEventListener('turbo:before-morph-element', this.#onBeforeMorph);
    document.addEventListener('turbo:submit-end', this.#onSubmitEnd);

    if (this.openValue) this.open();
  }

  disconnect() {
    window.removeEventListener('turbo:before-render', this.#onBeforeRender);
    document.removeEventListener('turbo:before-morph-element', this.#onBeforeMorph);
    document.removeEventListener('turbo:submit-end', this.#onSubmitEnd);
    this.close();
  }

  open() {
    this.dialogTarget.showModal();
  }

  close() {
    this.dialogTarget.close();
  }

  closeOnBackdrop(event) {
    if (event.target === this.dialogTarget) this.close();
  }

  #onBeforeRender;
  #onBeforeMorph;
  #onSubmitEnd;
}
